module.exports = __webpack_public_path__ + "static/media/laptop-image.28f7aee3.png";